import { Injectable } from '@angular/core';
import { URLSearchParams, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { PropertyLookupSummary } from '../../models/property-lookup-summary';
import { PropertyLookupDetail } from '../../models/property-lookup-detail';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../utils/response-util.service';
import { AppAuthHttpService } from '../../../http/app.auth.http.service';
import { PropertySearchRequest } from '../../models/property-search-request';
import { Page } from '../../models/page';
import { PropertyLookupDetailQuery } from '../../models/property-lookup-detail-query';
import { VendorSearchRequest } from 'app/shared/models/vendor-search-request';
import { PayorType } from 'app/event/models/common-data/payorType';

@Injectable()
export class PropertyLookupHttpService {

  private propertySearchURL = `${this.environment.baseUrl}/api/lookup/properties`;
  private propertyAdvancedSearchURL = `${this.environment.baseUrl}/api/lookup/properties/advanced`;
  private propertyDetailsURL = `${this.environment.baseUrl}/api/lookup/properties/details`;
  private vendorTypeEndpoint = '/payorType';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  search(propertyName: string): Observable<List<PropertyLookupSummary>> {
    let params = new URLSearchParams();
    params.set('propertyName', propertyName);

    return this.http.get(this.propertySearchURL, { search: params })
      .map((res: Response) => res.json().map(object => new PropertyLookupSummary(object)))
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  advancedSearch(searchRequest: PropertySearchRequest): Observable<Page<PropertyLookupSummary>> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.post(`${this.propertyAdvancedSearchURL}`, JSON.stringify(searchRequest), options)
      .map((res: Response) => res.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  advancedVendorSearch(searchRequest: VendorSearchRequest): Observable<Page<PropertyLookupSummary>> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.post(`${this.propertyAdvancedSearchURL}`, JSON.stringify(searchRequest), options)
      .map((res: Response) => res.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getDetail(propertyQuery: PropertyLookupDetailQuery): Observable<PropertyLookupDetail> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.post(`${this.propertyDetailsURL}`, JSON.stringify(propertyQuery), options)
      .map(response => new PropertyLookupDetail(response.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getPayorTypes(): Observable<PayorType[] | Response> {
    return this.http.get(`${this.propertySearchURL}${this.vendorTypeEndpoint}`)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/lookup/property-lookup/property-lookup.http.service.ts